<!-- 满意度 -->
<template>
  <div class="m-panel">
    <div class="m-panel-bar">
      <div class="m-panel-bar-title">
        {{title}}
      </div>
    </div>
    <div class="m-panel-body">
      <div class="base-box">
        <div class="left">
          <div class="base-item" v-for="item in list" :key="item.text">
            <!-- <div class="base-img"><img src="@/assets/images/menu-yw.png" alt="" /></div> -->
            <div class="base-text">
              <div>{{item.text}}</div>
              <div><i>{{item.num}}</i></div>
            </div>
          </div>
        </div>
        <div class="right">
          <div id="chart1" style="width: 100%;height: 100%;"></div>
        </div>
      </div>
      <div class="chart">
        <Echart ref="option" :options="option" style="height: 100%"></Echart>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    postAction
  } from '@/api/manage'
  import echarts from 'echarts/lib/echarts'
  // import * as echarts from 'echarts'
  export default {
    data() {
      return {
        title: this.$t('本年满意度统计'),
        url: {
          querySatisfactionDistributionInformation: "/jeecg-engineering/ticket/index/largeScreen/querySatisfactionDistributionInformation",
          querySatisfactionNumByHalf: "/jeecg-engineering/ticket/index/largeScreen/querySatisfactionNumByHalf",
          querySatisfactionTypeInformation: "/jeecg-engineering/ticket/index/largeScreen/querySatisfactionTypeInformation",
        },
        list: [{
            text: this.$t('好评量'),
            num: 0
          },
          {
            text: this.$t('差评量'),
            num: 0
          },
        ],
        option: {}
      }
    },
    mounted() {},
    methods: {
      setOption1(data) {
        let lenged = [this.$t('非常不满意'),this.$t('不满意'),this.$t('一般'),this.$t('满意'),this.$t('非常满意')];
        let seriesData = [];
        data.map(da=>{
          seriesData.push({
            name: lenged[da.level-1],
            value: da.levelTotal
          });
        });
        var chartDom = document.getElementById('chart1');
        var myChart = echarts.init(chartDom);
        var option = {
          color: ['#B620E0','#4634FA','#0394FF','#FA6400','#E02020'],
          // color: ['#FECA20', '#50E3C2', '#FA6400', '#0091FF', '#0394FF', '#4634FA', '#0C2D82', '#B620E0','#32C5FF', '#99CC33',  '#E02020','#3A7BD5','#7ffa34','#CC9933','#FF99CC','#666633','#006600','#990033','#CCCCFF'],
          grid: {
            top: '15%',
            left: '3%',
            right: '3%',
            bottom: '3%',
            containLabel: true
          },
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          legend: {
            type: 'scroll',
            show: true,
            left: 'left',
            bottom: 'bottom',
            icon: 'circle',
            itemHeight: 8,
            textStyle: {
              color: '#CEE2FF',
              fontSize: '12px'
            },
          },
          series: [{
            name: this.$t('满意度'),
            type: 'pie',
            radius: [0, 70],
            center: ['50%', '50%'],
            roseType: 'area',
            itemStyle: {
              borderRadius: 5,
              borderWidth: 2
            },
            label:{
              color: '#fff',
              formatter: function(params) {
                return `${params.name}:${params.value}`
              },
            },
            labelLine:{
              normal:{
                length:1,
                length2:10
              }
            },
            data: seriesData
          }]
        }
        option && myChart.setOption(option);
        // 为窗口加上宽度变化事件，当宽高发生改变时，调用echarts的resize()方法，调整图表尺寸
        window.addEventListener('resize', function () {
          myChart.resize();
        })
      },
      setOption2(data) {
        let numData = [];
        let rateData = [];
        let xData = [];
        data.map(val=>{
          numData.push(val.num)
          rateData.push((val.acclaimRate*100).toFixed(0))
          xData.push(val.time)
        });
        let seriesData = []
        seriesData[0] = {
          name: this.$t('评论量'),
          type: 'bar',
          barMaxWidth: 14,
          stack: 'sum',
          smooth: true,
          symbol: "none",
          animationDelay: (0 * 200) - 100,
          animationDuration: 300,
          data: numData
        }
        seriesData[1] = {
          name: this.$t('好评率(%)'),
          type: 'line',
          yAxisIndex: 1,
          symbol: 'circle',
          animationDelay: 1000,
          stack: 'Total',
          smooth: true,
          animationDuration: 300,
          data: rateData
        }
        this.$refs.option.hideLoading()
        this.option = {
          color: ['#4634FA', '#50E3C2', '#F6BB2F',  '#32C5FF', '#0091FF', '#0394FF', '#0C2D82', '#B620E0', '#F7B500',
            '#FA6400', '#E02020'
          ],
          title: {
            show: false
          },
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(0,11,42,0.9)',
            borderColor: '#5D6A94',
            borderWidth: 1,
            borderRadius: 8,
            textStyle: {
              color: '#CEE2FF',
            },
            axisPointer: {
              type: 'line',
              lineStyle: {
                color: '#019AF3'
              }
            },
            formatter: '{b0}<br/>{a0}: {c0}<br/>{a1}: {c1}%'
          },
          legend: {
            show: true,
            type: 'scroll',
            data: [this.$t('评论量'), this.$t('好评率(%)')],
            textStyle: {
              color: '#CEE2FF'
            },
            // icon: 'circle',
            itemHeight: 10,
            left: 'center',
          },
          grid: {
            left: '3%',
            right: '3%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: true,
            data: xData,
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: ['#074671'],
              }
            },
            axisLabel: {
              color: '#D1F3FF',
              fontSize: 10
            }
          },
          yAxis: [{
              type: 'value',
              name: this.$t('评论量(个)'),
              nameTextStyle: {
                color: '#D1F3FF',
                align: 'center',
              },
              splitLine: {
                show: true,
                lineStyle: {
                  type: 'dotted',
                  color: ['#074671'],
                }
              },
              axisTick: {
                show: false
              },
              axisLine: {
                show: false
              },
              axisLabel: {
                color: '#D1F3FF',
                fontSize: 10
              }
            },
            {
              type: 'value',
              min: 0,
              max: 100,
              interval: 20,
              name: this.$t('好评率(%)'),
              nameTextStyle: {
                color: '#D1F3FF',
                align: 'center',
              },
              splitLine: {
                show: false,
                lineStyle: {
                  type: 'dotted',
                  color: ['#074671'],
                }
              },
              axisTick: {
                show: false
              },
              axisLine: {
                show: false
              },
              axisLabel: {
                formatter: '{value} %',
                color: '#D1F3FF',
                fontSize: 10
              }
            }
          ],
          series: seriesData
        };
      },
      init() {
        this.getData1();
        this.getData2();
        this.getData3();
      },
      getData1() {
        postAction(this.url.querySatisfactionDistributionInformation, {}).then(res => {
          if (res.success) {
            var data = res.result;
            this.setOption1(data);
          }
        })
      },
      getData2() {
        postAction(this.url.querySatisfactionNumByHalf, {}).then(res => {
          if (res.success) {
            var data = res.result;
            this.setOption2(data);
          }
        })
      },
      getData3() {
        postAction(this.url.querySatisfactionTypeInformation, {}).then(res => {
          if (res.success) {
            var data = res.result;
            this.list[0].num = data.acclaim;
            this.list[1].num = data.badReviews;
          }
        })
      }
    },
  }
</script>
<style lang="less" scoped>
  .base-box {
    display: flex;
    height: 50%;

    .left {
      width: 25%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;

      .base-item {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 40%;
        border: 1px dashed #00FAFE;
        border-radius: 2px;
        background-color: #20515B;

        .base-img {
          width: 50px;
          height: 50px;
          margin-right: 25px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .base-text {
          display: flex;
          flex-direction: column;
          align-items: center;
          color: #fff;
          font-size: 15px;
        }
      }
    }

    .right {
      width: 75%;
    }
  }

  // .base-item:first-child{
  //   margin-bottom: 10px;
  // }
  .chart {
    height: 50%;
  }
</style>